import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { Observable, of } from 'rxjs';

import { ConfigService } from './config.service';
import { switchMap } from "rxjs/operators";
import { FileService } from "./file.service";
import { HouseShareFile } from "../models/file/file";

@Injectable()
export class ImageService {
    constructor(private http: HttpClient, private configService: ConfigService, private fileService: FileService) {
    }

    getImageData(file: HouseShareFile): Observable<string> {
        if (file.dataString){
            return of(file.dataString);
        }

        return this.fileService.getSignedUrl(file.reference)
            .pipe(
                switchMap(data => {
                    return this.http.get(data.signedUrl, { responseType: 'blob' }).pipe(
                        switchMap(blob => this.convertBlobToBase64(blob))
                    );
                })
            );
    }

    private convertBlobToBase64(blob: Blob): Observable<string> {
        return new Observable<string>((observer) => {
            const reader = new FileReader();

            reader.onerror = error => observer.error(error);
            reader.onload = () => {
                observer.next(reader.result as string);
                observer.complete();
            };

            reader.readAsDataURL(blob);
        });
    }
}
